import { render, staticRenderFns } from "./comment-base-subtitle.vue?vue&type=template&id=23e1f3b4"
import script from "./comment-base-subtitle.vue?vue&type=script&lang=js"
export * from "./comment-base-subtitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports